import {
  createFileRoute,
  Outlet,
  useRouterState,
} from '@tanstack/react-router';

import { NavBar } from '@/shared/components/navBar';

export const Route = createFileRoute('/_protected/_app/_mainLayout')({
  beforeLoad: () => ({
    hideNavBar: false,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const hideNavBar = useRouterState({
    select: ({ matches }) =>
      matches
        .map(({ context }) =>
          'hideNavBar' in context ? context.hideNavBar : undefined,
        )
        .filter(it => it !== undefined)
        .pop() ?? false,
  });

  return (
    <>
      <div className="h-full w-full">
        <Outlet />
      </div>
      {!hideNavBar && <NavBar />}
    </>
  );
}
